import { RequestAPIUrlModel } from '../models/BaseRequestModel';
       
export class BaseResponseModel {      
    public isSuccess: boolean;
    public errorMessages: string[];
    public messages: string[];
    public variant: string;

  // Constructor
    constructor() {
        this.isSuccess = false;
        this.errorMessages = [];
        this.messages = [];        
    }

    toPayload() {
      return {
        payload : {
          isSuccess : this.isSuccess,
          errorMessages : this.errorMessages,
          messages : this.messages
        }
      }
    }
}

export class BaseResponseAPIModel<T> {  
    public body: T;
    public requestModelUrl: RequestAPIUrlModel;
    public isSuccess: false;
    public errorMessages: string[];
    public messages: string[];

  // Constructor
    constructor(body:T, requestModelUrl: RequestAPIUrlModel) { //, isSuccess : false, errorMessages : [], messages : []) {
        this.isSuccess = false;
        this.errorMessages = [];
        this.messages = [];
        this.body = body;
        this.requestModelUrl = requestModelUrl;
    }
}

export interface APIResponseModel<T> {
  data: Array<T>;
};
